<template>
  <form class="card auth-card" @submit.prevent="submitHanlder">
    <div class="card-content">
      <span class="card-title">Домашняя бухгалтерия</span>
      <div class="input-field">
        <input
          id="email"
          type="text"
          :class="{'invalid': ($v.email.$dirty && !$v.email.required) || ($v.email.$dirty && !$v.email.email)}"
          v-model.trim="email"
        />
        <label for="email">Email</label>
        <small
          class="helper-text invalid"
          v-if="!$v.email.email && $v.email.$dirty"
        >Введите корректный Email</small>
        <small
          class="helper-text invalid"
          v-if="!$v.email.required && $v.email.$dirty"
        >Поле не должно быть пустым</small>
      </div>
      <div class="input-field">
        <input id="password" type="password"  
        :class="{'invalid': ($v.password.$dirty && !$v.password.required) || ($v.password.$dirty && !$v.password.minLength )}"
        v-model.trim="password"/>
        <label for="password">Пароль</label>
        <small class="helper-text invalid" v-if="$v.password.$dirty && !$v.password.required"> Введите пароль</small>
        <small class="helper-text invalid" v-if="$v.password.$dirty && !$v.password.minLength"> Длина пароля не менее {{$v.password.$params.minLength.min}}. Сейчас он {{password.length}}</small>
      </div>
      <div class="input-field">
        <input id="name" type="text" :class="{'invalid': ($v.name.$dirty && !$v.name.required)}"
        v-model.trim="name"/>
        <label for="name">Имя</label>
        <small class="helper-text invalid" v-if="$v.name.$dirty && !$v.name.required"> Введите свое имя</small>
      </div>
      <p>
        <label>
          <input type="checkbox" v-model="law"/>
          <span>С правилами согласен</span>
        </label> <br>
        <small class="helper-text invalid" v-if="$v.law.$dirty && !$v.law.isTrue">Нужно принять правила</small>
      </p>
    </div>
    <div class="card-action">
      <div>
        <button class="btn waves-effect waves-light auth-submit" type="submit">
          Зарегистрироваться
          <i class="material-icons right">send</i>
        </button>
      </div>

      <p class="center">
        Уже есть аккаунт?
        <a href="/login">Войти!</a>
      </p>
    </div>
  </form>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
export default {
  metaInfo(){
    return {
      title: this.$title('register')
    }
  },
  data: () => ({
    email: "",
    password: "",
    name: "",
    law: false
  }),
  methods: {
    async submitHanlder() {
      if (this.$v.email.$invalid || this.$v.password.$invalid || this.$v.name.$invalid || this.$v.law.$invalid) {
        this.$v.email.$touch();
        this.$v.password.$touch();
        this.$v.name.$touch();
        this.$v.law.$touch();
        return;
      }
      const userData = {
        email: this.email,
        password: this.password,
        name: this.name,
      };
      
      try{
        await this.$store.dispatch('reg', userData);
        this.$router.push("/");
      } catch (e){}
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(6)
    },
    name: {required},
    law: {isTrue: (value) => value}
  }
};
</script>